import React from "react";
import {
  User,
  Smartphone,
  CalendarDays,
  IndianRupee,
  Pencil,
  Trash2,
  PauseCircle,
  PlayCircle,
  ShieldCheck,
  AlertTriangle,
  Clock3
} from "lucide-react";

import "./SubscriptionTable.css";

const formatCurrency = (value) =>
  `₹ ${Number(value || 0).toLocaleString("en-IN")}`;

const formatDate = (date) => {

  if (!date) return "-";

  return new Date(date).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });

};

export default function SubscriptionTable({

  filteredSubscriptions,
  onEdit,
  onToggleSuspend,
  onDelete

}) {

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const thirtyDays = new Date(today);
  thirtyDays.setDate(today.getDate() + 30);


  if (filteredSubscriptions.length === 0) {

    return (

      <div className="empty-table">

        <div className="empty-circle">

          <User size={42} />

        </div>

        <h3>

          No subscriptions found

        </h3>

        <p>

          No records are available for the selected filter.

        </p>

      </div>

    );

  }

  return (

    <div className="table-card">

      <div className="table-header">

        <div>

          <h2>

            Subscription Directory

          </h2>

          <span>

            {filteredSubscriptions.length} Client Records

          </span>

        </div>

      </div>

      <div className="table-responsive">

        <table className="subscription-table">

          <thead>

            <tr>

              <th>Client</th>

              <th>Type</th>

              <th>Serial Numbers</th>

              <th>WhatsApp</th>

              <th>Selling</th>

              <th>Renewal</th>

              <th>Expiry</th>

              <th>Status</th>

              <th style={{ textAlign: "center" }}>

                Actions

              </th>

            </tr>

          </thead>

          <tbody>

            {

              filteredSubscriptions.map(sub => {

                const expiry = new Date(sub.expiryDate);

                let status = "Active";
                let badge = "success";
                let icon = <ShieldCheck size={15} />;

                if (sub.isSuspended) {

                  status = "Suspended";
                  badge = "secondary";
                  icon = <PauseCircle size={15} />;

                }

                else if (expiry < today) {

                  status = "Expired";
                  badge = "danger";
                  icon = <AlertTriangle size={15} />;

                }

                else if (expiry <= thirtyDays) {

                  status = "Expiring";
                  badge = "warning";
                  icon = <Clock3 size={15} />;

                }

                return (

                  <tr key={sub.id}>

                    <td>

                      <div className="client-info">

                        <div className="client-avatar">

                          <User size={18} />

                        </div>

                        <div>

                          <div className="client-name">

                            {sub.clientName}

                          </div>

                          {

                            sub.remark &&

                            <div className="client-remark">

                              {sub.remark}

                            </div>

                          }

                        </div>

                      </div>

                    </td>

                    <td>

                      <span className="type-chip">

                        {sub.type}

                      </span>

                    </td>

                    <td>

                      <div className="serial-list">

                        {

                          sub.serialNumbers.map((serial, index) => (

                            <span
                              key={index}
                              className="serial-chip"
                            >

                              {serial}

                            </span>

                          ))

                        }

                      </div>

                    </td>

                    <td>

                      <div className="whatsapp-cell">

                        <Smartphone size={15} />

                        <span>

                          {sub.whatsappUsername || "-"}

                        </span>

                      </div>

                    </td>

                    <td>

                      <div className="money-cell">

                        <IndianRupee size={15} />

                        {Number(sub.sellingRate).toLocaleString("en-IN")}

                      </div>

                    </td>

                    <td>

                      <div className="money-cell">

                        <IndianRupee size={15} />
                        {Number(sub.renewalRate).toLocaleString("en-IN")}

                      </div>

                    </td>

                    <td>

                      <div className="expiry-cell">

                        <CalendarDays size={15} />

                        {formatDate(sub.expiryDate)}

                      </div>

                    </td>

                    <td>

                      <span className={`status-chip ${badge}`}>

                        {icon}

                        <span>

                          {status}

                        </span>

                      </span>

                    </td>

                    <td>

                      <div className="table-actions">

                        <button
                          className="action-btn edit"
                          title="Edit Subscription"
                          onClick={() => onEdit(sub)}
                        >

                          <Pencil size={16} />

                        </button>

                        <button
                          className={`action-btn ${sub.isSuspended
                              ? "activate"
                              : "suspend"
                            }`}
                          title={
                            sub.isSuspended
                              ? "Activate Subscription"
                              : "Suspend Subscription"
                          }
                          onClick={() =>
                            onToggleSuspend(sub.id)
                          }
                        >

                          {

                            sub.isSuspended
                              ?

                              <PlayCircle size={17} />

                              :

                              <PauseCircle size={17} />

                          }

                        </button>

                        <button
                          className="action-btn delete"
                          title="Delete Subscription"
                          onClick={() =>
                            onDelete(
                              sub.id,
                              sub.clientName
                            )
                          }
                        >

                          <Trash2 size={16} />

                        </button>

                      </div>

                    </td>

                  </tr>

                );

              })

            }

          </tbody>

        </table>

      </div>

      <div className="table-footer">

        <div className="footer-left">

          Showing

          <strong>

            {" "}
            {filteredSubscriptions.length}
            {" "}

          </strong>

          of

          <strong>

            {" "}
            {filteredSubscriptions.length}
            {" "}

          </strong>

          subscriptions

        </div>

        <div className="footer-right">

          <ShieldCheck size={16} />

          Data synchronized with subscription records

        </div>

      </div>

    </div>

  );

}